module.exports={
    "census": "Census",
    "info": "Info",
    "share": "Share",
    "more": "More",
    "help": "Help",
    "moreOptions": "More options",
    "mapLoading": {
        "title": "Opening your map",
        "statuses": {
            "project": "Loading the map project…",
            "layers": "Fetching data layers…",
            "settings": "Preparing the base map…",
            "facilities": "Placing facilities on the map…"
        }
    },
    "details": "Details",
    "delete": "Delete",
    "done": "Done",
    "send": "Send",
    "add": "Add",
    "upload": "Upload",
    "off": "Off",
    "of": "of",
    "title": "Title",
    "reset": "Reset",
    "ok": "Ok",
    "okGotIt": "OK, Got It",
    "rename": "Rename",
    "description": "Description",
    "descriptionOptional": "Description (optional)",
    "save": "Save",
    "exportLayerAs": "Export layer as",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "source": "Source",
    "geography": "Geography",
    "close": "Close",
    "export": "Export",
    "categories": "Categories",
    "dataset": "Dataset",
    "classes": "Classes",
    "browse": "Browse",
    "zoom": "Zoom",
    "format": "Format",
    "untitledProject": "Untitled project",
    "annotations": "Annotations",
    "areYouSureYouWantToDelete": "Are you sure you want to delete",
    "mapsWithAlreadyAddedLayersMayStopWorking": "Maps with already added layers may stop working.",
    "sendFeedback": "Send Feedback",
    "preview": "Preview",
    "noData": "No data",
    "insufficientData": "Insufficient data",
    "name": "Name",
    "survey": "Survey",
    "table": "Table",
    "units": "Units",
    "noResults": "No results",
    "noResultsFound": "No results found",
    "loading": "Loading...",
    "searchIllustration": "Search illustration",
    "openEmbedInApp": "Open project in app",
    "visitWebsite": "Visit Website",
    "min": "min",
    "miles": "{count, plural, =1 {mile} other {miles}}",
    "mi": "mi",
    "edit": "Edit",
    "showInLegend": "Show in legend",
    "emptyValue": "Empty Value",
    "allItems": "All items",
    "toggleVisibility": "Toggle visibility",
    "clear": "Clear",
    "apply": "Apply",
    "any": "any",
    "selectValue": "Select value",
    "helpCenter": "Help Center",
    "status": "Status",
    "saveChanges": "Save changes",
    "saveCopy": "Save a copy",
    "emailSupportSubject": "Error in TractIQ platform",
    "oopsSomethingWentWrong": "Oops, something went wrong",
    "pleaseTryReloadingThePage": "Please, try reloading the page.",
    "reload": "Reload",
    "criticalError": "Critical Error",
    "list": "List"
}
